import { render } from "./EmergenciesServiceComponent.vue?vue&type=template&id=cc2c5a08"
import script from "./EmergenciesServiceComponent.vue?vue&type=script&lang=js"
export * from "./EmergenciesServiceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__